import React, { useEffect, useState } from "react";
import { getCorrectCategoryNames } from "../../components/reusable/Percepciones/functions";
import { getPerceptionSurveyData } from "../../services/dashboard";
import ReactECharts from "echarts-for-react";
import { TOOLTIP_STYLE } from "../../utils/constants/graphConfigs";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/carousel.json";
import ErrorLoading from "../../components/404/ErrorLoading";
import miscText from "../../utils/text/misc.json";
import "./CarouselGraphs.css";


const LatinobarometerOptionsTree_ES = require("../../utils/opinions/percepciones_latinobarometro.json");

/**
 *
 * @returns SurveyJobs component for Homepage carousel
 */
export default function SurveyGraph({ question}) {
  const { language } = useCurrentLanguage();
  const [options, setOptions] = useState(null);
  const [errorLoadingData, setErrorLoadingData] = useState(false);

  const getOptions = (isSmall, data) => {
    return {
      color: ["#305EA9", "#1C97C9"],
      title: {
        text: TEXT[question]["title"][language],
        subtext: TEXT[question]["subtitle"][language],
        top: "top",
        left: "center",
        textStyle: {
          color: "white",
          fontSize: isSmall ? 12 : 20,
          width: isSmall ? 260 : 500,
          overflow: "break",
        },
        subtextStyle: {
          fontSize: isSmall ? 9 : 14,
        },
      },
      xAxis: {
        type: "category",
        nameLocation: "middle",
        axisTick: { show: false },
        data: TEXT[question]["categories"][language],
        axisLabel: {
          margin: 10,
          fontSize: isSmall ? 10 : 16,
          fontColor: "white",
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "white",
          },
        },
      },
      yAxis: {
        type: "value",
        showMaxLabel: "false",
        splitLine: {
          show: false,
        },
        axisLabel: {
          margin: 10,
          fontSize: isSmall ? 10 : 16,
          fontColor: "white",
          formatter: (value) => {
            return value + "%";
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "white",
          },
        },
      },

      label: {
        show: true,
        fontSize: "14px",
        fontFamily: "Open Sans",
        formatter: function (params) {
          return params.value.toFixed(1) + "%";
        },
      },
      grid: {
        left: isSmall ? "15%" : "100px",
        top: "23%",
        height: isSmall ? "65%" : "70%",
        width: isSmall ? "75%" : "87%",
      },
      tooltip: {
        ...TOOLTIP_STYLE,
        show: true,
        formatter: function (params) {
          return (
            "<span>" +
            params.name +
            "</span><br/> " +
            params.value.toFixed(1) +
            "%"
          );
        },
      },
      series: [
        {
          type: "bar",
          itemStyle: { borderRadius: [20, 20, 0, 0] },
          data: data,
        },
      ],
    };
  };

  useEffect(() => {
    const getData = async () => {
      const response = await getPerceptionSurveyData(
        "LAC",
        "latinobarometro_23",
        question,
        "GENERAL"
      );

      if (response !== "ERROR_LOADING_DATA") {
        let categories = getCorrectCategoryNames(
          { optionsTree: LatinobarometerOptionsTree_ES },
          "latinobarometro_23",
          question,
          response.data.categories.slice()
        );

        setOptions({
          categories: categories,
          data: response.data,
        });
        setErrorLoadingData(false);
      } else {
        setErrorLoadingData(true);
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="carousel-graph-container">
      {!errorLoadingData ? (
        <>
          <div className="carousel-graph-ss">
            {options ? (
              <ReactECharts
                option={getOptions(true, options.data.data)}
                style={{ height: "100%", width: "100%" }}
              />
            ) : null}
          </div>
          <div className="carousel-graph-ls ">
            {options ? (
              <ReactECharts
                option={getOptions(false, options.data.data)}
                style={{ height: "100%", width: "100%" }}
              />
            ) : null}
          </div>
          <div className="white source margin-top">
            {miscText["sourceText"][language]}:{" "}
            {TEXT[question]["source"][language]}
          </div>
        </>
      ) : (
        <div className="carousel-error-wrapper">
          <ErrorLoading background={"dark"} language={language} />
        </div>
      )}
    </div>
  );
}
